import { LearningObject } from "./learning-object.model";
import { Material } from "./material.model";

export class LearningObjective {
  constructor(
    public chapter: string = "",
    public chapterDescription: string = "",
    public course: string = "",
    public description: string = "",
    public duration: number = 0,
    public id: string = "",
    public learningObjectGroupers: LearningObject[],
    public learningObjective: LearningObject,
    public learningObjectiveId: string = "",
    public name: string = "",
    public required: boolean = false,
    public existsQuiz: boolean = false,
    public nameStudent: string = "",
    public materials?: Material[],
    public lessonPlan?: string
  ) {}
}
class FeedbackQuestion {
  constructor(
    public prompt: string,
    public answered: boolean,
    public rate: number
  ) {}
}
export class FeedbackObjective {
  constructor(
    public feedbackQuestionList: Array<FeedbackQuestion>,
    public feedbackText: string,
    public learningObjectiveId: string = ""
  ) {}
}
